import { createAction } from 'redux-actions';

export interface setToastAction {
	payload: {
		active: boolean;
		error: boolean;
		label: string;
		actionType: string;
	};
}

export const setToast: any = createAction('SET_TOAST', (action: setToastAction) => action);

export const hideToast: any = createAction('HIDE_TOAST', () => null);
